import React from 'react';

type AppProps = {
  value: string;
  testId?: string | null;
};

const Boolean: React.FC<AppProps> = ({ value, testId = null }) => {
  return (
    <p className="text-sm font-medium" data-testid={testId}>
      {value ? 'Yes' : 'No'}
    </p>
  );
};

export default Boolean;
